import React from 'react';

import BalanceDetailNavbar from '../BalanceDetailNavbar';
import BalanceDetailInfo from '../BalanceDetailInfo';
import BalanceDetailItemList from '../BalanceDetailItemList';

import Can from '../../../../components/common/Can';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../constants/service/common/userPermissions';

const BalanceListWrap = (props) => {
  const { form, setData, balanceDetail, editBalance } = props;

  return (
    <div className="balance-detail-wrap">
      {/*하단 네브바*/}
      <Can I={PERMISSION_ACTIONS.UPDATE} a={PERMISSION_SUBJECTS.BALANCE}>
        <BalanceDetailNavbar status={balanceDetail.balanceInfo.status} editBalance={editBalance} />
      </Can>
      {/*정산 정보*/}
      <BalanceDetailInfo form={form} setData={setData} balanceInfo={balanceDetail.balanceInfo} />

      {/*정산 아이템 리스트*/}
      <BalanceDetailItemList balanceItemList={balanceDetail.balanceItemList} />
    </div>
  );
};

export default BalanceListWrap;
